// reduced/modified version of https://github.com/hkk12369/pico-emitter/blob/main/index.js

class PicoEmitter {
  private _t: EventTarget
  private _callbackMap: Map<(args: any[]) => void, EventListener>

  constructor () {
    try {
      this._t = new EventTarget()
    } catch (e) {
      this._t = document.createDocumentFragment()
    }
    this._callbackMap = new Map()
  }

  $on (name: string, callback: (args: any[]) => void, options?: boolean | AddEventListenerOptions) {
    const pCallback = (e: Event) => callback(...(e as any)._p)
    this._t.addEventListener(name, pCallback, options)
    this._callbackMap.set(callback, pCallback)
  }

  $off (name: string, callback: (args: any[]) => void) {
    const pCallback = this._callbackMap.get(callback)
    if (pCallback) {
      this._t.removeEventListener(name, pCallback)
      this._callbackMap.delete(callback)
    }
  }

  $emit (name: string, ...args: any[]) {
    const e = new Event(name)
    ;(e as any)._p = args
    this._t.dispatchEvent(e)
  }
}

const emitter = new PicoEmitter()

export default emitter
